import { render, staticRenderFns } from "./Wwo.vue?vue&type=template&id=491a65c1&scoped=true&"
import script from "./Wwo.vue?vue&type=script&lang=ts&"
export * from "./Wwo.vue?vue&type=script&lang=ts&"
import style0 from "./Wwo.vue?vue&type=style&index=0&id=491a65c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a65c1",
  null
  
)

export default component.exports